export const DateTimeFormatter = (DateTime:Date, DateDebut:Boolean) => {
    const months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const split = `${DateTime}`.split(" ")
    if (DateDebut) {
        if (months_arr.indexOf(split[1])+1 < 10) {
            return (`${split[3]}-0${(months_arr.indexOf(split[1])+1)}-${split[2]} ${split[4]}`)
        }
        else {
            return  (`${split[3]}-${(months_arr.indexOf(split[1])+1)}-${split[2]} ${split[4]}`)
        }
    } else {
        if ((months_arr.indexOf(split[1])+1) < 10) {
            return  (`${split[3]}-0${(months_arr.indexOf(split[1])+1)}-${split[2]} ${split[4]}`)
        }
        else {
            return  (`${split[3]}-${(months_arr.indexOf(split[1])+1)}-${split[2]} ${split[4]}`)
        }
    }
}